import { Flex, theme } from '../../component-library';

const Holding = () => {
  return (
    <Flex>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        style={{ margin: 'auto', background: 'none', display: 'block', shapeRendering: 'auto', animationPlayState: 'running' }}
        width='297px'
        height='297px'
        viewBox='0 0 100 100'
        preserveAspectRatio='xMidYMid'
      >
        <g transform='translate(20 50)' style={{ animationPlayState: 'running', animationDelay: '0s' }}>
          <circle cx='0' cy='0' r='6' fill={theme.colors.primary} style={{ animationPlayState: 'running', animationDelay: '0s' }}>
            <animateTransform
              attributeName='transform'
              type='scale'
              begin='-0.3826530612244898s'
              calcMode='spline'
              keySplines='0.3 0 0.7 1;0.3 0 0.7 1'
              values='0;1;0'
              keyTimes='0;0.5;1'
              dur='1.0204081632653061s'
              repeatCount='indefinite'
              style={{ animationPlayState: 'running', animationDelay: '0s' }}
            ></animateTransform>
          </circle>
        </g>
        <g transform='translate(40 50)' style={{ animationPlayState: 'running', animationDelay: '0s' }}>
          <circle cx='0' cy='0' r='6' fill={theme.colors.primary} style={{ animationPlayState: 'running', animationDelay: '0s' }}>
            <animateTransform
              attributeName='transform'
              type='scale'
              begin='-0.25510204081632654s'
              calcMode='spline'
              keySplines='0.3 0 0.7 1;0.3 0 0.7 1'
              values='0;1;0'
              keyTimes='0;0.5;1'
              dur='1.0204081632653061s'
              repeatCount='indefinite'
              style={{ animationPlayState: 'running', animationDelay: '0s' }}
            ></animateTransform>
          </circle>
        </g>
        <g transform='translate(60 50)' style={{ animationPlayState: 'running', animationDelay: '0s' }}>
          <circle cx='0' cy='0' r='6' fill={theme.colors.primary} style={{ animationPlayState: 'running', animationDelay: '0s' }}>
            <animateTransform
              attributeName='transform'
              type='scale'
              begin='-0.12755102040816327s'
              calcMode='spline'
              keySplines='0.3 0 0.7 1;0.3 0 0.7 1'
              values='0;1;0'
              keyTimes='0;0.5;1'
              dur='1.0204081632653061s'
              repeatCount='indefinite'
              style={{ animationPlayState: 'running', animationDelay: '0s' }}
            ></animateTransform>
          </circle>
        </g>
        <g transform='translate(80 50)' style={{ animationPlayState: 'running', animationDelay: '0s' }}>
          <circle cx='0' cy='0' r='6' fill={theme.colors.primary} style={{ animationPlayState: 'running', animationDelay: '0s' }}>
            <animateTransform
              attributeName='transform'
              type='scale'
              begin='0s'
              calcMode='spline'
              keySplines='0.3 0 0.7 1;0.3 0 0.7 1'
              values='0;1;0'
              keyTimes='0;0.5;1'
              dur='1.0204081632653061s'
              repeatCount='indefinite'
              style={{ animationPlayState: 'running', animationDelay: '0s' }}
            ></animateTransform>
          </circle>
        </g>
      </svg>
    </Flex>
  );
};

export default Holding;
